export const PIC_ROLES = [
  { key: "chief_dispt", label: "Chief Dispt" },
  { key: "traffic_train_ctrl", label: "Traffic & Train Ctrl" },
  { key: "facility_service", label: "Facility Service" },
  { key: "power_dispt", label: "Power Dispt" },
  { key: "masinis", label: "Masinis" },
];

export const TEAM_ROLES = PIC_ROLES.filter((r) => r.key !== "masinis");

const MONTHS_ID = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

export function formatDateID(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  if (!y || !m || !d) return iso;
  return `${d} ${MONTHS_ID[m - 1]} ${y}`;
}

export function formatWaktu(w) {
  if (!w) return "";
  return /^\d{2}:\d{2}$/.test(w) ? `${w.replace(":", ".")} WIB` : w;
}

export function buildReport(f) {
  const pic = f.pic || {};
  const picLines = PIC_ROLES.map((r) => `${r.label}: ${pic[r.key] || ""}`).join("\n");
  return [
    `*Laporan Keterlambatan ${formatDateID(f.tanggal)}*`,
    f.judul || "",
    "",
    "1. *Waktu Kejadian* :",
    formatWaktu(f.waktu),
    "",
    "2. *Kejadian dan Dampak*:",
    f.kejadian || "",
    "",
    "3. *Penanganan Gangguan*:",
    f.penanganan || "",
    "",
    "4. *Penyebab Gangguan (dugaan root cause)* :",
    f.penyebab || "",
    "",
    "5. *Person in Charge*:",
    picLines,
    "",
    "Demikian disampaikan, Terima kasih 🙏",
  ].join("\n");
}

export const CODE_FIELDS = ["kejadian", "penanganan", "penyebab"];

// Text a code provides for a given form field.
export function codeText(c, field) {
  if (field === "penanganan") return c.text || "";
  if (field === "kejadian") return c.kejadian || "";
  if (field === "penyebab") return c.penyebab || "";
  return "";
}

// Find a fully typed code token (followed by space/newline) anywhere in text.
export function findCompletedCode(text, codes) {
  if (!codes?.length || !text) return null;
  const map = new Map(codes.map((c) => [c.code.toUpperCase(), c]));
  const re = /(^|\s)([A-Za-z0-9_-]+)(?=[ \n])/g;
  let m;
  while ((m = re.exec(text))) {
    const c = map.get(m[2].toUpperCase());
    if (c) return { code: c, start: m.index + m[1].length, end: m.index + m[1].length + m[2].length };
  }
  return null;
}

// Prefix-match codes for the token right before the caret.
export function suggestCodes(text, caret, codes) {
  if (!codes?.length) return null;
  const m = text.slice(0, caret).match(/(^|\s)([A-Za-z0-9_-]+)$/);
  if (!m) return null;
  const q = m[2].toUpperCase();
  const items = codes.filter((c) => c.code.startsWith(q) && c.code !== q).slice(0, 6);
  if (!items.length) return null;
  return { items, start: caret - m[2].length, end: caret };
}

// Merge a code's text into a field the user did not type in.
export function mergeText(cur, add) {
  if (!add) return cur || "";
  if (!cur) return add;
  if (cur.includes(add)) return cur;
  return `${cur.replace(/\s+$/, "")}\n${add}`;
}

// Apply code `c` typed in `field` at [start,end): replace token in that field,
// merge its texts into the other two fields.
export function applyCode(form, c, field, start, end) {
  const cur = form[field] || "";
  const own = codeText(c, field);
  const next = { ...form, [field]: `${cur.slice(0, start)}${own}${cur.slice(end)}` };
  for (const f of CODE_FIELDS) {
    if (f !== field) next[f] = mergeText(next[f], codeText(c, f));
  }
  return { form: next, caret: start + own.length };
}
